import {getCsrfToken} from './csrf' 

export function createRestResource(resource) {
    const base = `/api/${resource}/`

    function url(id = '', section = '') {
        if (section) return `${base}${section}/${id ? id+'/' : ''}`
        return id ? `${base}${id}/` : base
    }

    async function request(url, options = {}) {
        const csrfToken = getCsrfToken()

        const headers = options.headers ? { ...options.headers } : {}

        if (!(options.body instanceof FormData)) {
            headers['Content-Type'] = 'application/json'
        }

        headers['X-CSRFToken'] = csrfToken

        const res = await fetch(url, {
            credentials: 'same-origin',
            ...options,
            headers,
        })

        // console.log('[DEBUG] new request', url, options, res)

        if (!res.ok) {
            const text = await res.text()
            throw new Error(`API error on ${url}: ${text}`)
        }

        if (res.status === 204) return null

        return res ? res.json() : true
    }
    
    return {
        list(params = '', section = '') {
            return request(`${url('', section)}?${params}`)
        },

        query(id=null, endpoint=null, body=null) {
            console.log(id, endpoint, body, "<-- DIT")
            let url = id ? `${base}${id}/` : base
            if (endpoint) url += endpoint + '/'
            if (url) {
                const payload = body
                return request(url, {
                    method: "POST",
                    headers: payload instanceof FormData ? {} : { "Content-Type": "application/json" },
                    body: payload instanceof FormData ? payload : JSON.stringify(payload),
                })
            }
            return null
        },

        retrieve(id, section = '') {
            return request(url(id, section))
        },

        create(data, section = '') {
            let req = request(url('', section), {
                method: 'POST',
                body: data instanceof FormData
                    ? data
                    : JSON.stringify(data),
            })

            return req
        },

        update(id, data, section = '') {
            return request(url(id, section), {
                method: 'PUT',
                body: data instanceof FormData
                    ? data
                    : JSON.stringify(data),
            })
        },

        patch(id, data, section = '') {
            return request(url(id, section), {
                method: 'PATCH',
                body: data instanceof FormData
                    ? data
                    : JSON.stringify(data),
            })
        },

        destroy(id, section = '') {
            let req = request(url(id, section), {
                method: 'DELETE'
            })

            return true
        },
    }
}
